<template>
  <dl class="payment-methods">
    <dt class="payment-methods__title link-xstrong">
      {{ $t('text.footer.payment.methods') }}
    </dt>
    <dd
      v-for="(card, i) in acceptedCardTypes"
      :key="`accepted-card-${i}`"
      role="img"
      :aria-label="createCardAltText(card)"
      :class="`payment-icons-sprite payment-methods__${card}`"
      :qaid="`payment-methods-${card}-logo`"
    />
    <dd v-if="isIdealVisible" class="inline-block payment-methods__ideal" qaid="payment-methods-ideal-logo">
      <img
        :src="idealSrc"
        alt="ideal payment method"
        class="payment-methods__ideal"
        qaid="payment-methods-ideal-logo"
      />
    </dd>
  </dl>
</template>

<script>
export default {
  props: {
    acceptedCardTypes: {
      type: Array,
      default: () => [],
    },
    idealSrc: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    isIdealVisible() {
      return this.$store.state.locale === 'nl_NL';
    },
  },
  methods: {
    createCardAltText(cardName) {
      return `${cardName} payment method`;
    },
  },
};
</script>
